import axios from 'axios'

const instance = axios.create();
instance.defaults.baseURL = " https://api.countrystatecity.in/v1";
instance.defaults.headers = {
    'X-CSCAPI-KEY': 'WlJsMzJsaFJIeXRWV2gzeVdaRkphYmJvWGdaOHBackZHSFlYQTFPVA==',
}
export const getCountries = () => instance.get('/countries')
export const getStates = (countryId) => instance.get(`/countries/${countryId}/states`)
export const getCities = (countryId, stateId) => instance.get(`/countries/${countryId}/states/${stateId}/cities`)
export default instance;